import { connect } from 'react-redux';
import { pushAdoptsBuyerModal, pushAdoptsSellerModal } from '../../../../../../Modals/redux/actionCreators';
const mapDispatchToProps = (dispatch, ownProps)=>({
        sellerViewOffersModal: ()=>dispatch(pushAdoptsSellerModal(ownProps.deviation, 'offers')),
        sellerEditSaleModal: ()=>dispatch(pushAdoptsSellerModal(ownProps.deviation, 'update')),
        buyerViewOffersModal: ()=>dispatch(pushAdoptsBuyerModal(ownProps.deviation, 'view-offers')),
        buyerOfferModal: ()=>dispatch(pushAdoptsBuyerModal(ownProps.deviation, 'offer'))
    });
export default connect(null, mapDispatchToProps);
